<script>
  import Fuse from "fuse.js";
  import { focusTrap } from "svelte-focus-trap";
  import Timestamp from "./Timestamp.svelte";
  import Tag from "./Tag.svelte";
  import { onMount, createEventDispatcher } from "svelte";

  export let notes;

  const options = {
    includeScore: true,
    includeMatches: true,
    minMatchCharLength: 3,
    ignoreLocation: true,
    threshold: 0.2,
    keys: ["body"],
  };
  const fuse = new Fuse(notes.map(note => ({ ...note, body: note.body.replace(/(<([^>]+)>)/gi, " ") })), options);

  let noteHits = [];
  let allTags = [];
  let searchTerm = "";

  let delay;
  const debounce = (value) => {
    clearTimeout(delay);
    delay = setTimeout(() => {
      handleSearch(value);
    }, 250);
  };

  function handleSearch(keyword) {
    searchTerm = keyword;
    
    const result = fuse.search(keyword);
    console.log(result);

    getAllTags(result);

    noteHits = result.map((hit) => {
      return {
        id: hit.item.id,
        tags: hit.item.tags,
        time: hit.item.time,
        highlightBody: hit.item.body.substring(0, 250),
      };
    });
  }

  function getAllTags(hits) {
    allTags = hits.reduce((acc, hit) => {
      return hit.item.tags ? [...new Set([...acc, ...hit.item.tags])] : [];
    }, []);
  }

  //
  // Event handlers
  //
  const dispatch = createEventDispatcher();

  function closePopup() {
    dispatch("close", {});
  }

  function selectTag(tag) {
    dispatch("filterTag", { saveQuery: true, tag });
    closePopup();
  }

  function selectNote(id) {
    dispatch("filterNote", { saveQuery: true, id, searchTerm });
    closePopup();
  }

  function selectNotes() {
    const noteIds = noteHits.map((hit) => hit.id);
    dispatch("filterNotes", { saveQuery: true, noteIds, searchTerm });
    closePopup();
  }

  onMount(() => {
    document.getElementById("search").focus();
  });
</script>

<section>
  <div class="close" on:click={closePopup}>✕</div>
  <div class="contents" use:focusTrap>
    <input
      type="search"
      placeholder="search notes"
      id="search"
      on:keyup={({ target: { value } }) => debounce(value)}
    />
    {#if noteHits.length > 0}
      <ul>
        <li><button on:click={selectNotes}>Show all matches</button></li>
        <li>
          {#each allTags as tag}
            <Tag {tag} on:click={() => selectTag(tag)} />
          {/each}
        </li>
        <ul>
          {#each noteHits as hit}
            <li class="result">
              <a
                tabindex="0"
                href={null}
                on:click|preventDefault={() => selectNote(hit.id)}
              >
                {#if hit.time}
                  <span class="timestamp-container">
                    <Timestamp timestamp={hit.time} />
                  </span>
                {/if}
                <span>{@html hit.highlightBody}</span>
              </a>
            </li>
          {/each}
        </ul>
      </ul>
    {/if}
  </div>
</section>

<style>
  section {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 2;
    background: rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(4px);
  }

  .close {
    position: absolute;
    font-size: 1.5rem;
    top: 0.5rem;
    right: 0.75rem;
    cursor: pointer;
  }

  .contents {
    padding: 3rem 2rem;
    max-width: 75ch;
    max-height: 90vh;
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    height: 100%;
    overflow: auto;
    margin: 0 auto;
  }

  input {
    width: 100%;
    height: 2rem;
    background-color: #25282a;
    font-size: 20px;
    color: #ddd7d7;
    padding: 0.25rem 0.5rem;
  }

  ul {
    background-color: #25282a;
    padding-left: 0;
  }

  .contents > ul {
    border-radius: 4px;
    border: 1px solid #524c4c;
  }

  li {
    list-style-type: none;
    padding: 0.5rem;
    border-bottom: 1px solid #524c4c;
  }

  li.result {
    display: flex;
  }

  li a {
    color: #ddd7d7;
    text-decoration: none;
    display: flex;
    font-size: 0.8rem;
  }

  .timestamp-container {
    margin-right: 0.5rem;
  }

  :global(.highlight) {
    font-style: italic;
    font-weight: 500;
  }
</style>
